import { render, staticRenderFns } from "./HamburgerIcon.vue?vue&type=template&id=40c87b87"
import script from "./HamburgerIcon.vue?vue&type=script&lang=js"
export * from "./HamburgerIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports